(function ($) {

    // Simple Windows detection for measurement tolerance
    const isWindows = /Windows/i.test(navigator.userAgent);

    $.fn.textfill = function () {

        var fontSizeProperty = 'font-size';
        // Slightly larger tolerance on Windows to handle fractional rounding/DPI
        var measurementTolerance = isWindows ? 0.75 : 0.5;

        var pixelsPerUnit = { px: 1, pt: 96/72, mm: 96/25.4, in: 96, cm: 96/2.54 };

        function convertToPixels(value, unit)  { return value * (pixelsPerUnit[unit] || 1); }
        function convertFromPixels(pixelValue, targetUnit) { return pixelValue / (pixelsPerUnit[targetUnit] || 1); }
        function parseNumberWithDefault(input, defaultValue) {
            var parsed = parseFloat(input);
            return isNaN(parsed) ? defaultValue : parsed;
        }

        // Determine the decimal precision of a number
        function getDecimalPrecision(value) {
            var str = value.toString();
            if (str.indexOf('.') === -1) return 0; // Integer
            return str.split('.')[1].length;
        }

        // Calculate the appropriate search precision based on min/max values
        function calculateSearchPrecision(minValue, maxValue) {
            var minPrecision = getDecimalPrecision(minValue);
            var maxPrecision = getDecimalPrecision(maxValue);
            var highestPrecision = Math.max(minPrecision, maxPrecision);

            if (highestPrecision === 0) {
                // Both are integers, use 0.1 precision
                return 0.1;
            } else {
                // Use precision based on the most precise value
                return 1 / Math.pow(10, highestPrecision);
            }
        }

        function waitForFontsToLoad() {
            return (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
        }

        // Count only meaningful nodes (elements or non-whitespace text)
        function getMeaningfulChildNodes($containerElement) {
            return $containerElement.contents().filter(function () {
                var isElementNode = this.nodeType === 1;
                var isNonEmptyTextNode = this.nodeType === 3 && this.nodeValue.trim() !== '';
                return isElementNode || isNonEmptyTextNode;
            });
        }

        // Decide which element to apply font sizing to:
        // - Reuse existing __textfill_wrap__ if present.
        // - Apply __textfill_wrap__ class to single element child for consistency.
        // - Otherwise wrap all content once (and only once).
        function getTextSizingTarget($hostContainer) {
            var $existingTextWrapper = $hostContainer.children('.__textfill_wrap__');
            if ($existingTextWrapper.length) return $existingTextWrapper.eq(0);

            var $meaningfulNodes = getMeaningfulChildNodes($hostContainer);
            if ($meaningfulNodes.length === 1 && $meaningfulNodes[0].nodeType === 1) {
                var $singleElement = $meaningfulNodes.eq(0);

                // Apply __textfill_wrap__ class to existing element for consistency
                if (!$singleElement.hasClass('__textfill_wrap__')) {
                    $singleElement.addClass('__textfill_wrap__');
                }

                // Ensure stable measuring without changing DOM structure
                if ($singleElement.css('display') === 'inline') {
                    $singleElement.css('display', 'inline-block');
                }
                return $singleElement;
            }

            // Need a single sizing target: wrap content once
            var existingHTML = $hostContainer.html();
            $hostContainer.empty();
            var $textWrapper = $('<span class="__textfill_wrap__" style="display:inline-block;white-space:inherit;"></span>');
            $textWrapper.html(existingHTML);
            $hostContainer.append($textWrapper);
            return $textWrapper;
        }

        // Detect font unit from CSS first, then data attribute, then default to 'pt'
        function detectFontSizeUnit($textTarget, $hostContainer) {
            // First check the target element's inline style
            var inlineStyleFontSize = ($textTarget[0].style && $textTarget[0].style.fontSize) || '';
            var unitMatch = inlineStyleFontSize.match(/^ *([0-9.+-]+)\s*([a-z%]+) *$/i);
            if (unitMatch) return unitMatch[2].toLowerCase();

            // Check if container has inline style font-size
            var containerInlineStyleFontSize = ($hostContainer[0].style && $hostContainer[0].style.fontSize) || '';
            var containerUnitMatch = containerInlineStyleFontSize.match(/^ *([0-9.+-]+)\s*([a-z%]+) *$/i);
            if (containerUnitMatch) return containerUnitMatch[2].toLowerCase();

            // Fall back to data attribute if provided
            var dataAttributeUnit = $hostContainer.data('font-unit-type');
            if (dataAttributeUnit) return ('' + dataAttributeUnit).toLowerCase();

            // Default to pt (don't use computed CSS as it always returns pixels)
            return 'pt';
        }

        function resizeTextToFitContainer($hostContainer) {
            var $textTarget = getTextSizingTarget($hostContainer);
            var fontUnit = detectFontSizeUnit($textTarget, $hostContainer);
            var minimumFontSizeInUnit = parseNumberWithDefault($hostContainer.data('min-font-size'), 1);
            var maximumFontSizeInUnit = parseNumberWithDefault($hostContainer.data('max-font-size'), 32);

            // Calculate search precision based on supplied min/max values
            var searchPrecisionInUnit = calculateSearchPrecision(minimumFontSizeInUnit, maximumFontSizeInUnit);
            var searchPrecisionInPixels = convertToPixels(searchPrecisionInUnit, fontUnit);

            // Work in pixels internally for cross-platform consistency
            var minimumFontSizeInPixels = convertToPixels(minimumFontSizeInUnit, fontUnit);
            var maximumFontSizeInPixels = convertToPixels(maximumFontSizeInUnit, fontUnit);

            // Use jQuery methods to respect max-width/max-height constraints
            var containerWidth = $hostContainer.outerWidth();
            var containerHeight = $hostContainer.outerHeight();

            // Exit early if container has no dimensions (hidden, display:none, etc.)
            if (!containerWidth || !containerHeight) return;

            // Stabilize font shaping (helps Windows/variable fonts) — apply only on Windows
            if (isWindows) {
                $textTarget.css({
                    "font-optical-sizing": "none",
                    "font-variant-ligatures": "common-ligatures",
                    "font-synthesis": "none"
                });
            }

            function applyFontSize(fontSizeInPixels) {
                var fontSizeInOriginalUnit = convertFromPixels(fontSizeInPixels, fontUnit);

                // Round to match the precision of input values
                var decimalPlaces = Math.max(
                    getDecimalPrecision(minimumFontSizeInUnit),
                    getDecimalPrecision(maximumFontSizeInUnit)
                );
                if (decimalPlaces === 0) decimalPlaces = 1; // For 0.1 precision with integers

                fontSizeInOriginalUnit = Math.round(fontSizeInOriginalUnit * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);

                $textTarget.css(fontSizeProperty, fontSizeInOriginalUnit + fontUnit);
            }

            // Binary search for largest fitting font size with dynamic precision
            var smallestAcceptableSize = minimumFontSizeInPixels;
            var largestPossibleSize = maximumFontSizeInPixels;

            while (largestPossibleSize - smallestAcceptableSize > searchPrecisionInPixels) {
                var middleSize = (smallestAcceptableSize + largestPossibleSize) / 2;
                applyFontSize(middleSize);

                // Use jQuery methods for consistent dimension measurement
                var textWidth = $textTarget.outerWidth();
                var textHeight = $textTarget.outerHeight();
                var textFitsWidth = textWidth <= containerWidth + measurementTolerance;
                var textFitsHeight = textHeight <= containerHeight + measurementTolerance;

                if (textFitsWidth && textFitsHeight) {
                    smallestAcceptableSize = middleSize;
                } else {
                    largestPossibleSize = middleSize;
                }
            }

            applyFontSize(smallestAcceptableSize);
        }

        return this.each(function () {
            var $containerElement = $(this);

            // Early check to prevent processing hidden elements
            if ($containerElement.outerWidth() === 0 || $containerElement.outerHeight() === 0) {
                return;
            }

            waitForFontsToLoad().then(function () {
                resizeTextToFitContainer($containerElement);

                // Automatically refit when container resizes or more fonts load
                if (window.ResizeObserver) {
                    var containerResizeObserver = new ResizeObserver(function() {
                        resizeTextToFitContainer($containerElement);
                    });
                    containerResizeObserver.observe($containerElement[0]);
                }

                $(window).on('resize', function() {
                    resizeTextToFitContainer($containerElement);
                });

                if (document.fonts && document.fonts.addEventListener) {
                    document.fonts.addEventListener('loadingdone', function() {
                        resizeTextToFitContainer($containerElement);
                    });
                }

                // Support for manual triggering via 'text-fill' event
                $containerElement.on('text-fill', function() {
                    resizeTextToFitContainer($containerElement);
                });
            });
        });
    };
})(jQuery);
